export const firebaseAuthLoginError = (errorCode) => {
  return errorCode === "auth/user-not-found"
    ? "User didn't found"
    : errorCode === "auth/wrong-password"
    ? "Invalid Password"
    : "Something went wrong while logging you in";
};
